<template>
  <CommonLayout selectedNav="tasks">
    <div class="tx-wrap">
      <div class="tx-hero tx-hero-left">
        <h1 class="tx-hero-title">任务 <em>中心</em></h1>
        <p class="tx-hero-sub">转换任务与结果管理 · 隐私保护：上传文件与转换结果将在 7 天后自动删除</p>
      </div>

      <div class="tx-panel">
        <span class="tx-corner tl"></span><span class="tx-corner tr"></span>
        <span class="tx-corner bl"></span><span class="tx-corner br"></span>

        <div class="tx-task-head">
          <span class="tx-result-title"><i class="el-icon-files"></i> 我的任务</span>
          <el-button size="small" class="tx-mini-btn" :disabled="!hasFinished" @click="clearFinished">
            <i class="el-icon-delete"></i> 清空已完成
          </el-button>
        </div>

        <div class="tx-empty" v-if="!tasks.length">
          <i class="el-icon-folder-opened"></i>
          <p>暂无任务 — 前往首页上传文件并转换，任务会显示在这里</p>
          <router-link to="/" class="tx-link">去转换 →</router-link>
        </div>

        <el-table v-else :data="tasks" class="tx-table" style="width: 100%">
          <el-table-column prop="fileName" label="文件名" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column label="链路" width="130">
            <template slot-scope="scope">{{ scope.row.source }} → {{ scope.row.target }}
              <el-tag v-if="scope.row.kind === 'ocr'" size="mini" class="tx-ocr-tag">OCR</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <span class="tx-badge" :class="'tx-badge-' + scope.row.status">{{ statusText(scope.row.status) }}</span>
              <i v-if="scope.row.note" class="el-icon-warning-outline tx-note" :title="scope.row.note"></i>
            </template>
          </el-table-column>
          <el-table-column label="进度" min-width="140">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.progress" :status="progressStatus(scope.row)"
                :stroke-width="8" class="tx-progress"></el-progress>
              <!-- 页进度 + 剩余时间：**全部来自后端实测**（估不出就不显示，
                   不用「百分比 ÷ 已耗时」自己编 —— 那会让数字越等越大） -->
              <div v-if="scope.row.status === 'running' && etaOf(scope.row)" class="tx-eta">
                {{ etaOf(scope.row) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="保留倒计时" width="150">
            <template slot-scope="scope">
              <span class="tx-retain" v-if="scope.row.result">{{ scope.row.remainText }}</span>
              <span class="tx-retain-none" v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-link v-if="scope.row.result" type="success" :underline="false" class="tx-dl" @click="download(scope.row)">
                <i class="el-icon-download"></i> 下载
              </el-link>
              <el-link type="danger" :underline="false" class="tx-del" @click="delFile(scope.row)">
                <i class="el-icon-delete"></i> 删除我的文件
              </el-link>
              <el-tooltip v-if="scope.row.hint || scope.row.error" :content="scope.row.hint || scope.row.error" placement="top">
                <i class="el-icon-question tx-help"></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </CommonLayout>
</template>

<style scoped>
.tx-wrap {
  max-width: 1080px;
  margin: 0 auto;
  padding: 36px 28px 60px;
  animation: txFadeUp .5s ease both;
}

@keyframes txFadeUp {
  from { opacity: 0; transform: translateY(14px); }
  to { opacity: 1; transform: translateY(0); }
}

.tx-hero-left {
  text-align: left;
  margin-bottom: 26px;
}

.tx-hero-title {
  margin: 0 0 8px;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 4px;
  color: #e2f5ff;
}

.tx-hero-title em {
  font-style: normal;
  background: linear-gradient(90deg, #22d3ee, #818cf8, #22d3ee);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: txShine 4s linear infinite;
}

@keyframes txShine { to { background-position: 200% center; } }

.tx-hero-sub {
  margin: 0;
  color: #5b7295;
  font-size: 13px;
  letter-spacing: 1px;
}

.tx-panel {
  position: relative;
  padding: 22px;
  border-radius: 16px;
  background: rgba(13, 20, 36, .72);
  border: 1px solid rgba(56, 189, 248, .18);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 18px 50px rgba(0, 0, 0, .45);
}

.tx-corner {
  position: absolute;
  width: 14px;
  height: 14px;
  border-color: #22d3ee;
  border-style: solid;
  border-width: 0;
  filter: drop-shadow(0 0 4px rgba(34, 211, 238, .7));
}

.tx-corner.tl { top: -1px; left: -1px; border-top-width: 2px; border-left-width: 2px; }
.tx-corner.tr { top: -1px; right: -1px; border-top-width: 2px; border-right-width: 2px; }
.tx-corner.bl { bottom: -1px; left: -1px; border-bottom-width: 2px; border-left-width: 2px; }
.tx-corner.br { bottom: -1px; right: -1px; border-bottom-width: 2px; border-right-width: 2px; }

.tx-task-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.tx-result-title {
  color: #e2f5ff;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
}

.tx-result-title i {
  color: #22d3ee;
  margin-right: 4px;
}

.tx-mini-btn {
  background: rgba(34, 211, 238, .1) !important;
  border: 1px solid rgba(34, 211, 238, .35) !important;
  color: #a5f3fc !important;
}

.tx-table {
  background: transparent !important;
}

.tx-table::before { display: none; }

.tx-table th {
  background: rgba(56, 189, 248, .1) !important;
  color: #8fd8ee !important;
  border-bottom: 1px solid rgba(56, 189, 248, .25) !important;
  font-weight: 600;
}

.tx-table tr { background: transparent !important; }

.tx-table td {
  border-bottom: 1px solid rgba(56, 189, 248, .1) !important;
  color: #c7d7ee;
}

.tx-table .el-table__body tr:hover > td { background: rgba(56, 189, 248, .08) !important; }

.tx-progress .el-progress__text { color: #8fd8ee; font-size: 12px; }
.tx-eta {
  margin-top: 4px;
  color: #8fd8ee;
  font-size: 12px;
}

.tx-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
}

.tx-badge-queued { color: #94a3b8; background: rgba(148, 163, 184, .14); }
.tx-badge-running { color: #38bdf8; background: rgba(56, 189, 248, .14); }
.tx-badge-success { color: #34d399; background: rgba(52, 211, 153, .14); }
.tx-badge-failed { color: #f87171; background: rgba(248, 113, 113, .14); }

.tx-retain { color: #fbbf24; font-size: 12.5px; font-family: Consolas, Monaco, monospace; }
.tx-retain-none { color: #5b7295; }

.tx-dl { color: #34d399 !important; font-weight: 600; margin-right: 12px; }
.tx-dl:hover { color: #6ee7b7 !important; }
.tx-del { color: #f87171 !important; font-weight: 600; }
.tx-del:hover { color: #fca5a5 !important; }
.tx-help { color: #5b7295; cursor: help; margin-left: 6px; }

.tx-empty {
  margin-top: 4px;
  padding: 40px 20px;
  text-align: center;
  border: 1px dashed rgba(56, 189, 248, .2);
  border-radius: 14px;
  color: #5b7295;
}

.tx-empty i { font-size: 38px; color: rgba(34, 211, 238, .5); margin-bottom: 10px; display: block; }
.tx-empty p { margin: 0 0 10px; font-size: 13px; letter-spacing: 1px; }
.tx-link { color: #22d3ee; text-decoration: none; letter-spacing: 1px; }

@media (max-width: 768px) {
  .tx-wrap { padding: 22px 14px 48px; }
}
.tx-note {
  margin-left: 6px;
  color: #e6a23c;
  cursor: help;
}
</style>

<script>
import CommonLayout from './common/commonPage.vue';
import { taskStore, removeTask, clearFinished as storeClear, RETENTION_HOURS } from '../store';
import { downloadAndSave, deleteFile } from '../api/conversion';
import { normalizeError } from '../api/request';
import { progressLine } from '../utils/task';

export default {
  name: 'TasksPage',
  props: { selectedNav: { type: String, default: 'tasks' } },
  components: { CommonLayout },
  data() {
    return { now: Date.now() };
  },
  computed: {
    tasks() {
      return taskStore.tasks.map((t) => {
        const expire = (t.createdAt || Date.now()) + (t.retentionHours || RETENTION_HOURS) * 3600 * 1000;
        const remain = Math.max(0, expire - this.now);
        const h = Math.floor(remain / 3600000);
        const m = Math.floor((remain % 3600000) / 60000);
        const s = Math.floor((remain % 60000) / 1000);
        return Object.assign({}, t, { remainText: `${h}h ${String(m).padStart(2, '0')}m ${String(s).padStart(2, '0')}s` });
      });
    },
    hasFinished() {
      return taskStore.tasks.some((t) => t.status === 'success' || t.status === 'failed');
    },
  },
  methods: {
    /**
     * 运行中任务的页进度 / 剩余时间文案。
     * 只读后端字段（pagesDone / pagesTotal / etaSeconds），估不出返回空串 →
     * 模板整行不渲染。⛔ 不要再拿 progress 和 Date.now() 现算。
     */
    etaOf(row) {
      return progressLine(row);
    },
    statusText(status) {
      return { queued: '排队中', running: '转换中', success: '完成', failed: '失败' }[status] || status;
    },
    progressStatus(row) {
      if (row.status === 'success') return 'success';
      if (row.status === 'failed') return 'exception';
      return null;
    },
    download(row) {
      if (!row.result) return;
      const base = (row.fileName || 'file').replace(/\.[^.]+$/, '');
      this.$message.info('开始下载，大文件可能需要一些时间…');
      downloadAndSave(row.result, `${base}.${row.target}`)
        .then(() => this.$message.success('下载完成'))
        .catch(() => this.$message.error('下载失败，请确认后端在线'));
    },
    delFile(row) {
      const id = row.result || row.id;
      if (!id) {
        removeTask(row.id);
        this.$message.info('已移除本地记录');
        return;
      }
      this.$confirm('确定删除该文件？删除后不可恢复。', '隐私清理', { type: 'warning' })
        .then(() => deleteFile(id))
        .then(() => {
          removeTask(row.id);
          this.$message.success('已删除文件');
        })
        .catch((e) => {
          if (e === 'cancel' || e === 'close') return;
          const info = normalizeError(e);
          this.$message.warning('删除失败：' + info.message);
        });
    },
    clearFinished() {
      taskStore.tasks
        .filter((t) => t.status === 'success' || t.status === 'failed')
        .forEach((t) => { if (t.result) deleteFile(t.result).catch(() => {}); });
      storeClear();
      this.$message.success('已清空已完成任务');
    },
  },
  mounted() {
    this._timer = setInterval(() => { this.now = Date.now(); }, 1000);
  },
  beforeDestroy() {
    clearInterval(this._timer);
  },
};
</script>
